import React from 'react';
import { Box, Paper, Typography, useTheme } from '@mui/material';
import {
  BarChart,
  Bar,
  XAxis,
  ResponsiveContainer,
  LabelList,
} from 'recharts';

const WallLogbookGradeChart = ({ gradeDistribution = [] }) => {
  const theme = useTheme();

  if (!gradeDistribution.length) return null;

  return (
    <Paper sx={{ p: 3, mb: 3, border: 1, borderColor: 'divider', bgcolor: 'transparent' }}>
      <Typography variant="h6" gutterBottom>
        Distribuzione gradi
      </Typography>
      <Box sx={{ width: '100%', height: 260 }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={gradeDistribution} margin={{ top: 10, right: 20, left: 10, bottom: 10 }}>
            <XAxis
              dataKey="grade"
              stroke={theme.palette.text.secondary}
              fontSize={12}
              interval={0}
            />
            <Bar dataKey="count" fill={theme.palette.primary.main} radius={[6, 6, 0, 0]}>
              <LabelList
                dataKey="count"
                position="top"
                fill={theme.palette.text.primary}
                fontSize={12}
              />
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </Box>
    </Paper>
  );
};

export default WallLogbookGradeChart;
